// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
    baseUrl: "https://nmao-api-dev.azurewebsites.net",
    baseUrl_TEST:  "https://nmao-api-dev.azurewebsites.net",

    // baseUrl: "https://localhost:44326",
    // baseUrl_TEST:  "https://localhost:44326",

    // baseUrl: "https://nmao-api-stage.azurewebsites.net",
    // baseUrl_TEST: "https://nmao-api-stage.azurewebsites.net",
    minorLink: "https://apptest.loanspq.com/apply.aspx?enc=li4vaDVj_-KYKOppTSH6EM9_e-Bochy9R-luDX83Ag_zUoI9pXSevRkeUphwJ5KAm7luw4F8ETsTOEdJxLxcosE7kKmw4LMJvs4Zxyil_tw",
    alloy_Key: "7004c6cb-e3b7-45a5-a4f0-bd38cb474978",
    alloy_journeyToken: "J-2I9YIgE1eEextTixnJkr",
    alloy_production: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
